import SphereRobotTabs from '@common/enums/query-params/sphere-robot-tabs';

export const TAB_QUERY_STRING = 't';

export const parseEnumFromString = <T extends Record<string, string | number>>(
  enumObj: T,
  value: string | null,
): T[keyof T] => {
  return Math.max(
    Object.keys(enumObj)
      .filter((key) => isNaN(Number(key)))
      .map((key) => key.toString().toLowerCase())
      .findIndex((key) => key === value?.toLowerCase()),
    0,
  ) as unknown as T[keyof T];
};

export const parseStringFromEnum = <T extends Record<string, string | number>>(
  enumObj: T,
  enumValue: T[keyof T],
): string => {
  try {
    return enumObj[enumValue].toString().toLowerCase();
  } catch {
    return enumObj[0].toString().toLowerCase();
  }
};

export const isTabRoomRelated = (tab: string) => {
  return (
    tab !== SphereRobotTabs.History &&
    tab !== SphereRobotTabs.Dashboard &&
    tab !== SphereRobotTabs.Users &&
    tab !== SphereRobotTabs.Settings
  );
};
